<template>
  <div style="padding: 20px;position:relative;">
    <el-form ref="ruleForm" label-width="210px" class="demo-ruleForm" :rules="rules" :model="ruleForm"
      label-position="left">
      <div class="border-bo">风机排布 </div>
      <div style="width: 100%;height:20px"></div>
      <el-form-item label="陆上风场平均风速大于(m/s)" prop="wspd">
        <el-input v-model="ruleForm.wspd" :maxlength="10" oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="风机间距长轴大于(D)" prop="longAxisDistance">
        <el-input v-model="ruleForm.longAxisDistance" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="风机间距短轴大于(D)" prop="shortAxisDistance">
        <el-input v-model="ruleForm.shortAxisDistance" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="地形坡度小于(%)" prop="maxSlope">
        <el-input v-model="ruleForm.maxSlope" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="距边界距离大于(m)" prop="boundaryDistance">
        <el-input v-model="ruleForm.boundaryDistance" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="海上风场平均风速大于(m/s)" prop="wspdSea">
        <el-input v-model="ruleForm.wspdSea" :maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="地形海拔小于(m)" prop="defaultMaxAltitude">
        <el-input v-model="ruleForm.defaultMaxAltitude"></el-input>
      </el-form-item>
      <div class="border-bo">测风塔选址</div>
      <div style="width: 100%;height:20px"></div>
      <el-form-item label="代表半径大于(m)" prop="typicalRadius">
        <el-input v-model="ruleForm.typicalRadius"></el-input>
      </el-form-item>
      <el-form-item label="地形坡度小于(%)" prop="inflowAngle">
        <el-input v-model="ruleForm.inflowAngle"></el-input>
      </el-form-item>
      <el-form-item label="距边界距离大于(m)" prop="distance">
        <el-input v-model="ruleForm.distance"></el-input>
      </el-form-item>
      <div  class="border-bo">发电量计算
      </div>
      <div style="width: 100%;height:20px"></div>
      <el-form-item label="综合折减(%)" prop="synthesizeLoss">
        <el-input v-model="ruleForm.synthesizeLoss"></el-input>
      </el-form-item>
      <!-- <div style="font-size: 16pt;" class="border-bo">升压站设计
      </div>
      <div style="width: 100%;height:20px"></div>
      <el-form-item label="距机组最小安全距离(m)" prop="maxSafeDistance">
        <el-input v-model="ruleForm.maxSafeDistance"></el-input>
      </el-form-item>
      <el-form-item label="最大限制坡度(%)" prop="limitSlope">
        <el-input v-model="ruleForm.limitSlope"></el-input>
      </el-form-item>
      <div style="font-size: 16pt;" class="border-bo">道路设计
      </div>
      <div style="width: 100%;height:20px"></div>
      <el-form-item label="最大坡度(%)" prop="maxSlopeRoad">
        <el-input v-model="ruleForm.maxSlopeRoad"></el-input>
      </el-form-item>
      <el-form-item label="最大转弯半径(m)" prop="maxTurnRadius">
        <el-input v-model="ruleForm.maxTurnRadius"></el-input>
      </el-form-item> -->
      <!-- <el-form-item>
          
        </el-form-item> -->
    </el-form>
    <el-button @click="save" type="primary" id="baocun">保存</el-button>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        ruleForm: {
          labelposition: 'top',
          wspd: '',
          longAxisDistance: '',
          shortAxisDistance: '',
          maxSlope: '',
          boundaryDistance: '',
          wspdSea: '',

          defaultMaxAltitude: '',

          typicalRadius: '',
          inflowAngle: '',
          distance: '',

          synthesizeLoss: '',

          maxSlopeRoad: '',
          maxTurnRadius: '',

          maxSafeDistance: '',
          limitSlope: ''
        },

        rules: {
          wspd: [
            { required: true, message: '请输入平均风速', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          longAxisDistance: [
            { required: true, message: '请输入风机间距-长轴', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          shortAxisDistance: [
            { required: true, message: '请输入风机间距-短轴', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          maxSlope: [
            { required: true, message: '请输入地形坡度', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          boundaryDistance: [
            { required: true, message: '请输入距边界距离', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          wspdSea: [
            { required: true, message: '请输入平均风速', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          defaultMaxAltitude: [
            { required: true, message: '请输入海拔', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          typicalRadius: [
            { required: true, message: '请输入代表半径', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          inflowAngle: [
            { required: true, message: '请输入坡度', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          distance: [
            { required: true, message: '请输入距边界距离', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          synthesizeLoss: [
            { required: true, message: '请输入综合折减系数', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          maxSlopeRoad: [
            { required: true, message: '请输入坡度', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          maxTurnRadius: [
            { required: true, message: '请输入转弯半径', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          maxSafeDistance: [
            { required: true, message: '请输入距机组最小安全距离', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
          limitSlope: [
            { required: true, message: '请输入坡度', trigger: 'blur' },
            { pattern: /^[0-9]+(\.?[0-9]+)?$/, message: '只能输入数字', trigger: 'blur' }
          ],
        }
      };
    },
    async mounted() {
      await this.getWindfarmPlanDefaultCondition();
    },
    methods: {
      async getWindfarmPlanDefaultCondition() {
        const { data } = await this.$fetch(
          '/windfarm/station/getWindfarmPlanDefaultCondition',
          {
            module: 'manage'
          }
        );
        const {
          wspd,
          longAxisDistance,
          shortAxisDistance,
          maxSlope,
          boundaryDistance,
          wspdSea,
          defaultMaxAltitude,
          typicalRadius, inflowAngle, distance,
          synthesizeLoss,
          maxSlopeRoad, maxTurnRadius,
          maxSafeDistance, limitSlope
        } = data.defaultParam[0];
        this.ruleForm.wspd = wspd;
        this.ruleForm.longAxisDistance = longAxisDistance;
        this.ruleForm.shortAxisDistance = shortAxisDistance;
        this.ruleForm.maxSlope = maxSlope;
        this.ruleForm.boundaryDistance = boundaryDistance;
        this.ruleForm.wspdSea = wspdSea;
        this.ruleForm.defaultMaxAltitude = defaultMaxAltitude;

        this.ruleForm.typicalRadius = typicalRadius;
        this.ruleForm.inflowAngle = inflowAngle;
        this.ruleForm.distance = distance;
        this.ruleForm.synthesizeLoss = synthesizeLoss;

        this.ruleForm.maxSlopeRoad = maxSlopeRoad;
        this.ruleForm.maxTurnRadius = maxTurnRadius;
        this.ruleForm.maxSafeDistance = maxSafeDistance;
        this.ruleForm.limitSlope = limitSlope;
      },
      async save() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            await this.$postForm({
              url: '/windfarm/station/saveWindfarmPlanDefaultCondition',
              module: 'manage',
              data: this.ruleForm,
              showLoading: true,
              showError: true,
              showSuccess: true
            });
          } else {
            return false;
          }
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  #baocun {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  .border-bo {
    width: 100%;
    height: 45px;
    font-size: 16px;
    color: #fff;
    border-bottom: 1px solid #fff;
  }
 
  /* div /deep/.el-input-group>.el-input__inner {
    background-color: rgba(25, 25, 236, 0);
  } */
  /deep/.el-textarea {
    width: 25%;
  }

 div /deep/ .el-form-item {
    width: fit-content;

    margin-left: auto;

    margin-right: auto;
  }
</style>